import React from "react";
import { ArrowRight, Mail, Sparkles, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";
import data from "../data/retailData.json";
import { getIcon } from "../utils/iconResolver";

const { palette: P, cta } = data;

const RetailCTA = () => (
  <section style={{ background: P.bg, padding: "clamp(60px, 8vw, 96px) clamp(20px, 4vw, 40px)" }}>
    <div style={{ maxWidth: 1280, margin: "0 auto" }}>

    
      {/* Main CTA block */}
      <div style={{ background: P.darkBg, borderRadius: 28, padding: "clamp(48px, 7vw, 76px) clamp(24px, 6vw, 60px)", textAlign: "center", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle at 2px 2px, rgba(255,230,190,0.045) 1px, transparent 0)", backgroundSize: "44px 44px" }} />
        <div style={{ position: "absolute", top: "10%", left: "5%", width: 280, height: 280, borderRadius: "50%", background: "radial-gradient(circle, rgba(200,130,50,0.09) 0%, transparent 70%)" }} />
        <div style={{ position: "absolute", bottom: "8%", right: "5%", width: 320, height: 320, borderRadius: "50%", background: "radial-gradient(circle, rgba(93,162,162,0.11) 0%, transparent 70%)" }} />
        <div style={{ position: "absolute", top: -80, right: -80, width: 360, height: 360, borderRadius: "50%", background: "rgba(255,255,255,0.03)" }} />
        <div style={{ position: "absolute", bottom: -60, left: -60, width: 260, height: 260, borderRadius: "50%", background: "rgba(255,255,255,0.02)" }} />

        <div style={{ position: "relative" }}>
          {/* Icon */}
          <div style={{ width: 68, height: 68, background: "rgba(93,162,162,0.14)", border: "1px solid rgba(93,162,162,0.28)", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 28px" }}>
            <ShoppingBag style={{ width: 34, height: 34, color: P.tealLight }} />
          </div>

          {/* Badge */}
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(93,162,162,0.14)", border: "1px solid rgba(93,162,162,0.25)", color: P.tealLight, padding: "7px 18px", borderRadius: 100, fontSize: 12, fontWeight: 700, marginBottom: 24, letterSpacing: "0.06em" }}>
            <Sparkles style={{ width: 13, height: 13 }} /> {cta.block.badge}
          </div>

          <h2 style={{ fontSize: "clamp(28px, 5vw, 46px)", fontWeight: 900, color: "white", letterSpacing: "-0.025em", lineHeight: 1.08, marginBottom: 18 }}>
            {cta.block.headline.split("\n").map((line, i) => <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>)}
          </h2>
          <p style={{ fontSize: "clamp(14px, 2vw, 18px)", color: "rgba(255,255,255,0.50)", maxWidth: 540, margin: "0 auto 50px", lineHeight: 1.78 }}>{cta.block.description}</p>

          {/* Highlights grid */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 160px), 1fr))", gap: 14, maxWidth: 740, margin: "0 auto 50px" }}>
            {cta.block.highlights.map((h, i) => (
              <div key={i} style={{ background: "rgba(255,255,255,0.06)", borderRadius: 14, padding: "clamp(14px, 2vw, 18px) 14px", textAlign: "center", border: "1px solid rgba(255,255,255,0.08)" }}>
                <div style={{ color: P.tealLight, marginBottom: 9, display: "flex", justifyContent: "center" }}>
                  {getIcon(h.icon, { style: { width: 18, height: 18 } })}
                </div>
                <div style={{ color: "rgba(255,255,255,0.82)", fontSize: "clamp(11px, 1.4vw, 13px)", fontWeight: 600, lineHeight: 1.4 }}>{h.label}</div>
              </div>
            ))}
          </div>

          {/* Buttons */}
          <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
            {cta.block.buttons.map((btn, i) => (
              <Link key={i} to={btn.href}>
                {i === 0 ? (
                  <button style={{ padding: "clamp(12px, 2vw, 16px) clamp(28px, 4vw, 42px)", borderRadius: 11, fontSize: "clamp(13px, 1.5vw, 15px)", fontWeight: 700, background: "white", color: P.tealDark, border: "none", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 10, boxShadow: "0 8px 28px rgba(0,0,0,0.22)", transition: "all 0.25s" }}
                    onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 14px 38px rgba(0,0,0,0.30)"; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 8px 28px rgba(0,0,0,0.22)"; }}>
                    {btn.label} <ArrowRight style={{ width: 17, height: 17 }} />
                  </button>
                ) : (
                  <button style={{ padding: "clamp(12px, 2vw, 16px) clamp(28px, 4vw, 42px)", borderRadius: 11, fontSize: "clamp(13px, 1.5vw, 15px)", fontWeight: 700, background: "transparent", color: "rgba(255,255,255,0.82)", border: "1.5px solid rgba(93,162,162,0.38)", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 10, transition: "all 0.25s" }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor = P.teal; e.currentTarget.style.color = "white"; e.currentTarget.style.background = "rgba(93,162,162,0.10)"; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(93,162,162,0.38)"; e.currentTarget.style.color = "rgba(255,255,255,0.82)"; e.currentTarget.style.background = "transparent"; }}>
                    <Mail style={{ width: 16, height: 16 }} /> {btn.label}
                  </button>
                )}
              </Link>
            ))}
          </div>

          {/* Trust row */}
          <div style={{ display: "flex", gap: "clamp(16px, 3vw, 30px)", justifyContent: "center", marginTop: 34, flexWrap: "wrap" }}>
            {cta.block.trustPoints.map((t, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ width: 7, height: 7, borderRadius: "50%", background: t.dot }} />
                <span style={{ color: "rgba(255,255,255,0.38)", fontSize: "clamp(11px, 1.4vw, 13px)" }}>{t.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default RetailCTA;
